import { render } from "./CertificateDashboard.vue?vue&type=template&id=aa2bb494&ts=true"
import script from "./CertificateDashboard.vue?vue&type=script&lang=ts"
export * from "./CertificateDashboard.vue?vue&type=script&lang=ts"

import "./CertificateDashboard.vue?vue&type=style&index=0&id=aa2bb494&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__